<glxy-button-group>
  <button [disabled]="disabled()" data-action="suggest" (click)="this.suggest.emit()" type="button" mat-stroked-button>
    <mat-icon svgIcon="galaxy-ai-icon" />
    {{ 'GALAXY.AI_TEXT_BUTTON.SUGGEST' | translate }} {{ fieldName() }}
  </button>
  <button [matMenuTriggerFor]="optionsMenu" type="button" mat-stroked-button>
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
</glxy-button-group>

<mat-menu #optionsMenu>
  <button [disabled]="disabled()" (click)="this.suggest.emit()" mat-menu-item>Suggest {{ fieldName() }}</button>
  <button
    data-action="suggest-update"
    [disabled]="!this.value() || disabled()"
    (click)="suggestUpdate(UpdateOption.UNSPECIFIED)"
    mat-menu-item
  >
    {{ 'GALAXY.AI_TEXT_BUTTON.CREATE_FROM_CURRENT' | translate }}
  </button>
  <button [disabled]="!this.value() || disabled()" mat-menu-item [matMenuTriggerFor]="improvements">
    Improve Text
  </button>
</mat-menu>

<mat-menu #improvements yPosition="above" xPosition="after">
  <button data-action="suggest-update" (click)="suggestUpdate(UpdateOption.FIX_SPELLING_AND_GRAMMAR)" mat-menu-item>
    {{ 'GALAXY.AI_TEXT_BUTTON.SPELLING_AND_GRAMMAR' | translate }}
  </button>
  <button data-action="suggest-update" (click)="suggestUpdate(UpdateOption.MAKE_SHORTER)" mat-menu-item>
    Make shorter
  </button>
  <button mat-menu-item [matMenuTriggerFor]="tone">{{ 'GALAXY.AI_TEXT_BUTTON.CHANE_TONE' | translate }}</button>
</mat-menu>

<mat-menu #tone>
  @for (tone of tones; track tone) {
    <button data-action="suggest-update" (click)="suggestUpdate(UpdateOption.CHANGE_TONE, tone)" mat-menu-item>
      {{ tone.icon }} {{ tone.name | translate }}
    </button>
  }
</mat-menu>
